"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCSSVariable = void 0;
function isCSSVariable(value) {
    return /^var\((--.+?)\)$/.test(value.trim());
}
exports.isCSSVariable = isCSSVariable;
